import { render, staticRenderFns } from "./upparting.vue?vue&type=template&id=a06074ce&scoped=true"
import script from "./upparting.vue?vue&type=script&lang=ts"
export * from "./upparting.vue?vue&type=script&lang=ts"
import style0 from "./upparting.vue?vue&type=style&index=0&id=a06074ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a06074ce",
  null
  
)

export default component.exports